import React, { useRef, useState, useEffect } from "react";
import "../UserLogin/userlogin.scss";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { SmsValidator } from "../../../components";
import Api from "../../../core/Api";
import { StorageHelpers } from "../../../core/Helpers";
import { setToken, setUserToken } from "../../../redux/slices/authSlice";
import { setClinicName } from "../../../redux/slices/clinicSlice";
import InputMask from "react-input-mask";

const UserLogin = () => {
  const [showSmsValidationModal, setShowSmsValidationModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isPerson, setIsPerson] = useState(false);
  const [branches, setBranches] = useState([]);
  const [branchesLoading, setBranchesLoading] = useState(false);

  const getBranches = async () => {
    setBranchesLoading(true);
    try {
      const response = await Api.getBranchesAsync();
      setBranches(response.data.data);
    } finally {
      setBranchesLoading(false);
    }
  };

  useEffect(() => {
    getBranches();
  }, []);

  const formik = useFormik({
    initialValues: {
      firmType: 1,
      idNo: "",
      gsm: "",
      secField1: "",
      secField2: "",
      idBranch: 1,
    },
    validationSchema: Yup.object().shape({
      idNo: Yup.string()
        .required("Bu alan boş bırakılamaz.")
        .matches(/^[0-9]+$/, "Geçersiz TC / Vergi numarası girdiniz.")
        .min(10, "TC / Vergi Numarası 10 haneden düşük olamaz.")
        .max(11)
        .nullable(false),
      gsm: Yup.string().required("Bu alan boş bırakılamaz."),
      idBranch: Yup.number().required("Bu alan boş bırakılamaz."),
    }),

    onSubmit: async (val) => {
      setIsLoading(true);
      const response = await (!isPerson
        ? Api.adminLoginInspectCustomerAsync(val)
        : Api.adminLoginInspectAsync(val));
      setIsLoading(false);
      if (response.data.isSuccess) {
        toast.success("Başarıyla giriş yapıldı.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setShowSmsValidationModal(true);
      } else {
        toast.error("Hatalı giriş yaptınız.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    },
  });

  return (
    <div className="main-login-area flex flex-col animate__animated animate__fadeIn">
      <div className="duration-300 w-fit md:w-[500px] text-xl font-semibold p-4  flex flex-col items-center">
        <Link to="/login">
          <div className="w-full justify-center flex flex-col gap-2 mb-4 items-center ">
            <img className="w-96" src="/assets/images/logo.png" alt="Logo" />
          </div>
        </Link>
        <span className="text-2xl md:text-4xl font-bold drop-shadow-md mb-1 duration-300">
          Evet Login
        </span>
        <div className="flex w-full">
          <div
            onClick={() => {
              setIsPerson(false);
              formik.setFieldValue("firmType", 0);
            }}
            className={`${
              isPerson
                ? "bg-[#FFFFFF] text-black opacity-40"
                : " bg-[#4A9DEA] border-[#4A9DEA]"
            }  text-white p-1.5 w-full text-center border text-xl rounded-l-md  cursor-pointer  hover:opacity-80 px-12 duration-300`}
          >
            Tüzel
          </div>
          <div
            onClick={() => {
              setIsPerson(true);
              formik.setFieldValue("firmType", 1);
            }}
            className={`${
              isPerson
                ? " bg-[#4A9DEA] border-[#4A9DEA] "
                : "bg-[#FFFFFF] text-black opacity-40"
            }  text-white w-full text-center text-xl p-1.5 rounded-r-md px-12 border  cursor-pointer  hover:opacity-80 duration-300`}
          >
            Şahıs
          </div>
        </div>

        <div className="w-full justify-center flex flex-col mt-6">
          <form onSubmit={formik.handleSubmit}>
            <div className="mt-6 flex flex-col font-normal">
              <input
                type="text"
                value={formik.values.idNo}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Müşterinin TC Kimlik Numarası"
                maxLength="11"
                id="idNo"
                name="idNo"
                className={` ${
                  formik.errors.idNo && formik.touched.idNo && "border-red-600"
                } rounded-md white text-base p-2 pl-4 border-2`}
              />
            </div>
            <span className="text-xs flex text-red-600 duration-300">
              {formik.touched.idNo && formik.errors.idNo}
            </span>
            <div className="mt-6   flex flex-col font-normal">
              <InputMask
                type="text"
                id="gsm"
                name="gsm"
                placeholder="Müşterinin Telefon Numarası"
                value={formik.values.gsm}
                onBlur={formik.handleBlur}
                mask="999-999-99-99"
                onChange={formik.handleChange}
                className={`rounded-md white text-base p-2 pl-4  border-2 ${
                  formik.touched.gsm && formik.errors.gsm && "border-red-600"
                }`}
              ></InputMask>
            </div>
            <div className="mt-6   flex flex-col font-normal">
              <InputMask
                type="text"
                id="secField2"
                name="secField2"
                placeholder="Destekçinin Telefon Numarası"
                value={formik.values.secField2}
                onBlur={formik.handleBlur}
                mask="999-999-99-99"
                onChange={formik.handleChange}
                className={`rounded-md white text-base p-2 pl-4  border-2 ${
                  formik.touched.secField2 &&
                  formik.errors.secField2 &&
                  "border-red-600"
                }`}
              ></InputMask>
              <input
                type="text"
                value={formik.values.secField1}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                placeholder="Özel Kod"
                maxLength="99"
                id="secField1"
                name="secField1"
                className="rounded-md white text-base p-2 pl-4 border-2 mt-6"
              />
            </div>
            <span className="text-xs flex text-red-600 duration-300">
              {formik.touched.gsm && formik.errors.gsm}
            </span>
            <div className="mt-6 flex flex-col font-normal">
              <select
                value={formik.values.idBranch}
                onChange={(e) =>
                  formik.setFieldValue("idBranch", e.target.value)
                }
                className="rounded-md white text-base p-2 pl-4 border-2"
              >
                {branchesLoading ? (
                  <option value="">Yükleniyor...</option>
                ) : (
                  branches?.map((branch) => (
                    <option key={branch.idBranch} value={branch.idBranch}>
                      {branch.branchName}
                    </option>
                  ))
                )}
              </select>
            </div>
            <span className="text-xs flex text-red-600 duration-300">
              {formik.touched.idBranch && formik.errors.idBranch}
            </span>
            {/* <div className="flex justify-center mt-4">
              <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_SITE_KEY} />
            </div> */}
            <div className="flex mt-4 items-center">
              <button
                disabled={isLoading}
                type="submit"
                className={
                  isLoading
                    ? "bg-gray-600 w-full px-6 text-base py-3 rounded-md text-white hover:bg-gray-700 duration-200"
                    : "bg-green-500 w-full px-6 text-base py-3 rounded-md text-white hover:bg-green-600 duration-200"
                }
              >
                {isLoading ? "Giriş Yapılıyor..." : "Giriş Yap"}
              </button>
            </div>
          </form>
        </div>
        <SmsValidator
          isOpen={showSmsValidationModal}
          onClose={() => setShowSmsValidationModal(false)}
          isEvet={true}
          onVerify={(data) => {
            StorageHelpers.setAuthToken(data.token);
            dispatch(setToken(data.token));
            dispatch(setClinicName(data.name));
            navigate("/request-list");
          }}
          formikData={formik.values}
        />
      </div>
    </div>
  );
};

export default UserLogin;
